import modal from '../patterns/modal.js';
import { hasModalShown, modalHooks as isiModalHooks } from './modal-isi.js';
import PL_utils from '../patterns/pl-utils.js';
import Player from '@vimeo/player';

const videoModalEle = document.querySelector('.modal-video');
const isEDMode = window.location.href.indexOf('ed=1') > -1;
var instantiatedByEl = false;

/* eslint-disable */


const body = document.querySelector('body');
const videoModalEmbed = document.querySelector('.modal__body .video-wrapper');

const isIE11 = Boolean(window.MSInputMethodContext) && Boolean(document.documentMode);
const isEdge = navigator.appVersion.indexOf('Edge') > -1;

const vimeoModalHooks = {
    beforeClose: function (target) {
        if (target.classList.contains('active')) {
            window.eventsManager.emit("hideModal", { type: "modal-video", params: target.dataset.modal });
        }
        const vimeoContainers = target.querySelectorAll('.vimeo-container');
        vimeoContainers.forEach(vimeoContainer => {
            const player = new Player(vimeoContainer);
            player.pause();
        })
    },
}

const modalHooks = {
    _hasScrolledToBottom: false,
    _addModalError: function (target) { },
    _removeModalError: function (target) { },
    beforeOpen: function (target) {
        PL_utils.addClass('modal-open', body);
    },
    afterOpen: function (target) {
        // #1595903: in IE and Edge, clicks on video should play/pause video
        const video = target.querySelector('video');
        const playButton = target.querySelector('.px-video-play');
        const pauseButton = target.querySelector('.px-video-pause');

        if (video) {
            video.setAttribute('disablePictureInPicture', true);

            //video.play(); //Disable video autoplay

            video.onclick = () => {
                if (video.paused) {
                    video.play();
                    pauseButton.classList.remove('hide');
                    playButton.classList.add('hide');
                } else {
                    video.pause();
                    pauseButton.classList.add('hide');
                    playButton.classList.remove('hide');
                }
            };

            video.addEventListener('timeupdate', (e) => {
                if (e.target.ended) {
                    pauseButton.classList.add('hide');
                    playButton.classList.remove('hide');
                }
            });
        }
    },
    onContinue: function () {
        if (this._hasScrolledToBottom) {
            this._continueClicked = true;
            hasModalShown = true;

            isiModal.hideModal();
            if (typeof this.onContinueCallback === 'function') {
                this.onContinueCallback();
            }
        }
    },
    onCancel: function () { return false; },
    beforeClose: function (target) {
        if (target.classList.contains('active')) {
            window.eventsManager.emit("hideModal", { type: "modal-video", params: target.dataset.modal });
        }
        const videos = target.querySelectorAll('video');
        videos.forEach(video => {
            video.pause();
        });
    },
    afterClose: function () {
        if (instantiatedByEl) {
            instantiatedByEl.focus();
            instantiatedByEl = false;
        }
        PL_utils.removeClass('modal-open', body);
    },
    setSize: function () { return false; },
    onScreenshot: function () { return false; },
    onInit: function (target) { }
};

const modalOpts = {
    enableBackdropClose: true
};

const tabletSize = 960;
const videoModal = modal.initModal(videoModalEle, modalHooks, modalOpts);
const videoModalTriggers = document.querySelectorAll('.home-hero--tv-trigger');


function loadVideo() {
    appplyAccessibility(videoModalEle);
    videoModal.showModal();
    window.eventsManager.emit("showModal", { type: "modal-video", params: 'video' });
    
    
    const modalContent = videoModalEle.querySelector('.modal__body');
    if (modalContent) {
        modalContent.setAttribute('tabindex', '-1');
        modalContent.focus();
    } else {
        videoModalEle.focus();
    }

    if (window.location.href.indexOf('ed=1') > -1) {
        const closebutton = document.querySelectorAll('.modal__close');
        PL_utils.addClass("focus", closebutton[0]);
    }

    if (isIE11 || isEdge) {
        videoModalEmbed.querySelector('video').play();
    }

}

const appplyAccessibility = (ModalEle) => {
    const el_label = ModalEle.querySelector("[data-label]");
    if (el_label != null && !isEDMode) {
        ModalEle.setAttribute("aria-label", el_label.innerHTML);
        ModalEle.setAttribute("role", "dialog");
        ModalEle.setAttribute("aria-modal", "true");
        ModalEle.removeAttribute("hidden");
        ModalEle.removeAttribute("aria-hidden");
        ModalEle.setAttribute("tabIndex", "0");
    }
};


export default () => {
    if (videoModalEle) {
        PL_utils.eleOnClick(function (e) {
            e.preventDefault();
            loadVideo();
            instantiatedByEl = (e.target);
        }, videoModalTriggers);

        videoModalTriggers.forEach(trigger => {
            trigger.addEventListener('keydown', function(e) {
                if (e.key === 'Enter' || e.key === ' ') {
                    e.preventDefault();
                    loadVideo();
                    instantiatedByEl = this;
                }
            });
        });

        const storyTriggers = document.querySelectorAll('.video-trigger');
        const michaelModal = document.querySelector('[data-modal="video-michael"]');
        const jamieModal = document.querySelector('[data-modal="video-jamie"]');

        if (storyTriggers.length) {
            PL_utils.eleOnClick(function (e) {
                e.preventDefault();
                const modalTarget = e.currentTarget.dataset.modalTarget;
                instantiatedByEl = e.currentTarget;
                const showIsiModal = e.currentTarget.dataset.showIsiModal;

                if (!hasModalShown && showIsiModal !== 'false') {
                    // Show ISI modal first
                    const isiModalEle = document.querySelector('.modal-isi');
                    if (isiModalEle) {
                        isiModalHooks.onContinueCallback = function () {
                            showVideoModal(modalTarget);
                        }
                        const isiModalInstance = modal.initModal(isiModalEle, isiModalHooks, modalOpts);

                        appplyAccessibility(isiModalEle);
                        isiModalInstance.showModal();
                    }
                } else {
                    showVideoModal(modalTarget);
                }
            }, storyTriggers);

            storyTriggers.forEach(trigger => {
                trigger.addEventListener('keydown', function(e) {
                    if (e.key === 'Enter' || e.key === ' ') {
                        e.preventDefault();
                        const modalTarget = this.dataset.modalTarget;
                        instantiatedByEl = this;
                        const showIsiModal = this.dataset.showIsiModal;

                        if (!hasModalShown && showIsiModal !== 'false') {
                            const isiModalEle = document.querySelector('.modal-isi');
                            if (isiModalEle) {
                                isiModalHooks.onContinueCallback = function () {
                                    showVideoModal(modalTarget);
                                }
                                const isiModalInstance = modal.initModal(isiModalEle, isiModalHooks, modalOpts);

                                appplyAccessibility(isiModalEle);
                                isiModalInstance.showModal();
                            }
                        } else {
                            showVideoModal(modalTarget);
                        }
                    }
                });
            });
        }

        const isiModalTrigger = document.querySelectorAll('.modal-video [data-isi-scroll]');

        PL_utils.eleOnClick(function (e) {
            e.preventDefault();
            const currentModal = e.target.closest('.modal-video');

            if (currentModal) {
                const modalId = currentModal.getAttribute('data-modal');
                if (modalId === 'video') {
                    videoModal.hideModal();
                } else if (modalId === 'video-michael') {
                    const michaelModal = modal.initModal(currentModal, vimeoModalHooks, modalOpts);
                    michaelModal.hideModal();
                } else if (modalId === 'video-jamie') {
                    const jamieModal = modal.initModal(currentModal, vimeoModalHooks, modalOpts);
                    jamieModal.hideModal();
                } else if (modalId === 'video-what-to-expect') {
                    const whatToExpectModal = modal.initModal(currentModal, vimeoModalHooks, modalOpts);
                    whatToExpectModal.hideModal();
                }
            }
        }, isiModalTrigger);


        //screenshot
        if (window.location.href.indexOf('ed=1') > -1) {
            if (window.location.search.substring(1).split('&').indexOf('modal=video') > -1) {
                loadVideo();
            }
        }
    } else return
}

function showVideoModal(modalTarget) {
    const michaelModal = document.querySelector('[data-modal="video-michael"]');
    const jamieModal = document.querySelector('[data-modal="video-jamie"]');
    const whatToExpectModal = document.querySelector('[data-modal="video-what-to-expect"]');

    if (modalTarget === 'video-michael' && michaelModal) {
        const modalInstance = modal.initModal(michaelModal, vimeoModalHooks, modalOpts);
        appplyAccessibility(michaelModal);
        modalInstance.showModal();

        
        const modalContent = michaelModal.querySelector('.modal__body');
        if (modalContent) {
            modalContent.setAttribute('tabindex', '-1');
            modalContent.focus();
        } else {
            michaelModal.focus();
        }

        const vimeoContainer = michaelModal.querySelector('.vimeo-container');
        if (vimeoContainer) {
            const player = new Player(vimeoContainer);
            michaelModal.vimeoPlayer = player;
        }

        window.eventsManager.emit("showModal", { type: "modal-video", params: 'video-michael' });
    } else if (modalTarget === 'video-jamie' && jamieModal) {
        const modalInstance = modal.initModal(jamieModal, vimeoModalHooks, modalOpts);
        appplyAccessibility(jamieModal);
        modalInstance.showModal();

        
        const modalContent = jamieModal.querySelector('.modal__body');
        if (modalContent) {
            modalContent.setAttribute('tabindex', '-1');
            modalContent.focus();
        } else {
            jamieModal.focus();
        }

        const vimeoContainer = jamieModal.querySelector('.vimeo-container');
        if (vimeoContainer) {
            const player = new Player(vimeoContainer);
            jamieModal.vimeoPlayer = player;
        }

        window.eventsManager.emit("showModal", { type: "modal-video", params: 'video-jamie' });
    } else if (modalTarget === 'video-what-to-expect' && whatToExpectModal) {
        const modalInstance = modal.initModal(whatToExpectModal, vimeoModalHooks, modalOpts);
        appplyAccessibility(whatToExpectModal);
        modalInstance.showModal();

        
        const modalContent = whatToExpectModal.querySelector('.modal__body');
        if (modalContent) {
            modalContent.setAttribute('tabindex', '-1');
            modalContent.focus();
        } else {
            whatToExpectModal.focus();
        }

        const vimeoContainer = whatToExpectModal.querySelector('.vimeo-container');
        if (vimeoContainer) {
            const player = new Player(vimeoContainer);
            whatToExpectModal.vimeoPlayer = player;
        }

        window.eventsManager.emit("showModal", { type: "modal-video", params: 'video-what-to-expect' });
    }
}
